module.exports = __webpack_public_path__ + "img/ly_icon1.945a6ca.png";